import React, { useEffect, useState } from "react";
import { SessionService } from "../../services/DataService";
import { Button, Box } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import  {Buffer} from "buffer" 
import { PageHeader } from "../../components/Layout/PageHeader";
import { Translate } from 'react-i18nify';
import TimeUtils from "../../utils/TimeUtils";
import JSZip from "jszip";
import PageContainer from "../../components/PageContainer";


const SessionsFromStorage = () => {
    const [sessions, setSessions] = useState()
    
    const [groupedByPatient, setGroupedByPatient] = useState([])
    const [sessionsConverted, setSessionsConverted] = useState(false)
    const [sessionsFetched, setSessionsFetched] = useState(false)

    useEffect(() => {
        if(sessions && sessionsConverted === true){
            groupSessionsAndGenerateFile(sessions);
        }
    },[sessionsConverted])

    const fetchAndConvertData = async () => {
        const rawSessions = await getSessionsFromStorage();
        convertZipFileToJson(rawSessions);
    }

    const groupSessionsAndGenerateFile = (sessions) => {
        const groupedSessions = groupSessions(sessions);
        generateFile(groupedSessions);

    }

    const getSessionsFromStorage = async () => {
        console.log("getting sessions from storage");
        return await SessionService.getSessionsFromStorage().then((response) => {
            if(response.data === null){
                console.error("No sessions found in storage");
                return;
            }
            return response.data;
            // setRawSessions(response.data)
            // setSessionsFetched(true);
        }).catch((error) => {
            console.error("Error: ", error);
            setSessionsFetched(false);
        });
    }

    const convertZipFileToJson = async (data) => { //works with base64 encoded data
        let sessions = {}
        let zip = new JSZip();
        await zip.loadAsync(data, {optimizedBinaryString: true}).then((zip) => {
            for(const key in zip.files){
                zip.files[key].async("base64").then(data => {
                    let dataAsString = Buffer.from(data, "base64").toString("utf-8");
                    let jsonData = JSON.parse(dataAsString);
                    sessions[key] = jsonData;
                    
                    if(Object.keys(sessions).length === Object.keys(zip.files).length){
                        // return sessions;
                        console.log("progress: " + Object.keys(sessions).length + "/" + Object.keys(zip.files).length);
                        setSessions(sessions);
                        setSessionsConverted(true);
                    }
                }).catch(error => {
                    console.error("Error: ", error);
                })
            }
        }).catch(error => {
            console.error("Error: ", error);
        })
    }

    const groupSessions = (sessions) => {
        // console.log("grouping sessions");
        let groupedByPatientInitial = [];
        for(const key in sessions){
            // console.log("grouping ", sessions[key]);
            let patientToAdd = sessions[key].Patient
            if(!patientToAdd){
                continue;
            }
                
            let dsOrS = 0;
            let toAdd = {};
            if(key.includes("detailedsessions")){
                dsOrS = 1;
                toAdd = {"Values": sessions[key].DetailedSessionValues, "Treatment": sessions[key].Treatment, "Component": sessions[key].Component};
            }
            else if(key.includes("sessions")){
                dsOrS = 2;
                toAdd = sessions[key].Session;
                toAdd["LinkedToDetailedValue"] = false;
            }
            else 
                continue; //if session is not a session or detailed session, somthing is wrong an it should be skipped.

            let patientExists = groupedByPatientInitial.find((element) => {
               return element.Id === sessions[key].Patient.Id}
            );
            if(patientExists){
                //add to existing patient 
                patientToAdd = patientExists;
                if(dsOrS === 1){
                    patientToAdd.detailedSessions.push(toAdd);
                }
                else if(dsOrS === 2){
                    patientToAdd.sessions.push(toAdd);
                }

                groupedByPatientInitial = groupedByPatientInitial.map((oldPatient) => { //replace old patient with new patient.
                    if(oldPatient.Id === patientToAdd.Id){
                        return patientToAdd;
                    }else{
                        return oldPatient;
                    }
                });

            }else{
                //create new patient and add session data.
                if(dsOrS === 1){
                    patientToAdd.detailedSessions = [toAdd];
                    patientToAdd.sessions = [];
                }
                else if(dsOrS === 2){
                    patientToAdd.sessions = [toAdd];
                    patientToAdd.detailedSessions = [];
                }
                groupedByPatientInitial = [...groupedByPatientInitial, patientToAdd]; 
            }
        }
        setGroupedByPatient(groupedByPatientInitial);
        setSessions(undefined);
        console.log("grouped by patient: ", groupedByPatientInitial);
        return groupedByPatientInitial
    }

    const sortGroupedSessions = (data) => {
        data.forEach(element => {
            element.sessions.sort((el1, el2) => {
                return new Date(el1?.Parts.Start.Timestamp) - new Date(el2?.Parts.Start?.Timestamp);
            })
            element.detailedSessions.sort((el1, el2) => {
                return new Date(el1?.Start) - new Date(el2?.Start);
            })
            element.detailedSessions.forEach(ds => {
                ds.forEach(ds => {
                    ds.Values.sort((el1, el2) =>  {
                        return new Date(el1?.Timestamp) - new Date(el2?.Timestamp);
                    })
                })
            })
        })
    }

    const findSession = (patientSession, detailedSessionValue) => {
        const session = patientSession.sessions.find(session => {
            return (TimeUtils.dateToUTC(new Date(session.Parts.Start.Timestamp)) <= TimeUtils.dateToUTC(new Date(detailedSessionValue.Timestamp)) && TimeUtils.dateToUTC(new Date(session.Parts.End.Timestamp)) >= TimeUtils.dateToUTC(new Date(detailedSessionValue.Timestamp)))
        })
        if(session)
            session.LinkedToDetailedValue = true;
        return session;
    }

    const createRow  = (patientSession, treatment, component, session, dsValue) => {
        let row = [];
        row.push( 
            //Adding patient data
            patientSession?.Id,      
            patientSession?.Birthdate,
            patientSession?.Gender,

            //Adding treatment data
            treatment?.Id,        
            treatment?.Name,
            treatment?.ClinicalTrial ? "Yes" : "No",
            treatment?.Values?.find(value => value.Code === "HSpO2")?.Value,//Upper SpO2 target range
            treatment?.Values?.find(value => value.Code === "LSpO2")?.Value,//Lower SpO2 target range
            treatment?.Values?.find(value => value.Code === "HO2LT")?.Value,//Upper O2 target range without sensor
            treatment?.Values?.find(value => value.Code === "LO2LT")?.Value,//Lower O2 target range without sensor
            treatment?.Values?.find(value => value.Code === "HO2LT")?.Value,//Upper O2 target range with sensor
            treatment?.Values?.find(value => value.Code === "LO2ST")?.Value,//Lower O2 target range with sensor
            treatment?.Values?.find(value => value.Code === "DurLod1")?.Value,//Analysing phase duration
            treatment?.Values?.find(value => value.Code === "Ki")?.Value,//Flow response rate
            treatment?.Values?.find(value => value.Code === "OAD")?.Value,//Fration of time with pulse oximeter

            component?.Id,
            component?.MetaData?.find(metaData => metaData.MetadataId === 1).Value, //Serial number
            component?.MetaData?.find(metaData => metaData.MetadataId === 14).Value, //Software version
            component?.MetaData?.find(metaData => metaData.MetadataId === 15).Value, //Firmware version
            component?.MetaData?.find(metaData => metaData.MetadataId === 11).Value, //DMR version

            //Adding sessions data         
            session?.Id,
            session?.Parts.Start.Timestamp,
            session?.Parts.Start.Values.OxygenInitial,
            session?.Parts.Start.Values.PulseInitial,
            session?.Parts.Start.Values.SpO2Initial,
            session?.Parts.Adjusting.Timestamp,
            session?.Parts.Adjusting.Values.Duration,
            session?.Parts.Adjusting.Values.OxygenAverage,
            session?.Parts.Adjusting.Values.OxygenMaximum,
            session?.Parts.Adjusting.Values.OxygenMinimum,
            session?.Parts.Adjusting.Values.OxygenStandardDeviation,
            session?.Parts.Adjusting.Values.PulseAverage,
            session?.Parts.Adjusting.Values.PulseMaximum,
            session?.Parts.Adjusting.Values.PulseMinimum,
            session?.Parts.Adjusting.Values.PulseStandardDeviation,
            session?.Parts.Adjusting.Values.SpO2Average,
            session?.Parts.Adjusting.Values.SpO2Maximum,
            session?.Parts.Adjusting.Values.SpO2Minimum,
            session?.Parts.Adjusting.Values.SpO2StandardDeviation,
            session?.Parts.Analyzing.Timestamp,
            session?.Parts.Analyzing.Values.OxygenAverage,
            session?.Parts.Analyzing.Values.OxygenMaximum,
            session?.Parts.Analyzing.Values.OxygenMinimum,
            session?.Parts.Analyzing.Values.OxygenStandardDeviation,
            session?.Parts.Analyzing.Values.PulseAverage,
            session?.Parts.Analyzing.Values.PulseMaximum,
            session?.Parts.Analyzing.Values.PulseMinimum,
            session?.Parts.Analyzing.Values.PulseStandardDeviation,
            session?.Parts.Analyzing.Values.SpO2Average,
            session?.Parts.Analyzing.Values.SpO2Maximum,
            session?.Parts.Analyzing.Values.SpO2Minimum,
            session?.Parts.Analyzing.Values.SpO2StandardDeviation,
            session?.Parts.End.Timestamp,
            session?.Parts.End.Values.NextDiagnosis,
            session?.Parts.End.Values.NextDiagnosisSeconds,
            session?.Parts.End.Values.OxygenTarget,
            session?.Parts.End.Values.PulseFinal,
            session?.Parts.End.Values.SpO2Final,
            session?.Parts.End.Values.Zone,
            
            //Adding detailed session data
            dsValue?.O2,
            dsValue?.Pulse,
            dsValue?.SpO2,
            dsValue?.Timestamp
        )
        return row;
    }

    const generateFile = (data) => {
        let rows = [
            ["sep=;"],
            ["Session data from storage"],
            [
                "Anon patient id", //Patient
                "Date of birth", 
                "Gender",

                "Treatment Id", //Treatment
                "Treatment name",
                "Clinical Trial", 
                "Upper SpO2 target range",
                "Lower SpO2 target range",
                "Upper O2 target range without sensor",
                "Lower O2 target range without sensor",
                "Upper O2 target range with sensor",
                "Lower O2 target range with sensor",
                "Analysing phase duration", 
                "Flow response rate",
                "Fration of time with pulse oximeter",

                "Component Id", //Component
                "Serial number",
                "Software version",
                "Firmware version",
                "DMR version",

                "Session Id", //Sessions Start
                "Start time", //Start
                "Oxygen initial",
                "SpO2 initial",
                "Pulse initial",
                "Adjusting timestamp", //Adjusting
                "Adjusting duration",
                "Oxygen average",
                "Oxygen max",
                "Oxygen min",
                "Oxygen standard deviation",
                "Pulse average",
                "Pulse max",
                "Pulse min",
                "Pulse standard deviation",
                "SpO2 average",
                "SpO2 max",
                "SpO2 min",
                "SpO2 standard deviation",
                "Analyzing timestamp", //Analyzing 
                "Oxygen average",
                "Oxygen max",
                "Oxygen min",
                "Oxygen standard deviation",
                "Pulse average",
                "Pulse max",
                "Pulse min",
                "Pulse standard deviation",
                "SpO2 average",
                "SpO2 max",
                "SpO2 min",
                "SpO2 standard deviation",
                "End timestamp", //End
                "Next diagosis",
                "Next diagnosis seconds",
                "Oxygen target",
                "Pulse final",
                "SpO2 final",
                "Zone",

                "O2", // Detailed session data
                "Pulse",
                "SpO2",
                "Timestamp",
            ]
        ]
        data.sort(patientSession => patientSession.id)
        data.forEach(patientSession => {
            patientSession.detailedSessions.forEach(ds => {
                let session = findSession(patientSession, ds.Values[0]);

                ds.Values.forEach(value => {
                    if(session == null || !(TimeUtils.dateToUTC(new Date(session.Parts.Start.Timestamp)) <= TimeUtils.dateToUTC(new Date(value.Timestamp)) && TimeUtils.dateToUTC(new Date(session.Parts.End.Timestamp)) >= TimeUtils.dateToUTC(new Date(value.Timestamp))))
                        session = findSession(patientSession, value);

                    const rowWithValue = createRow(patientSession, ds.Treatment, ds.Component, session, value);
                    rows.push(rowWithValue);
                })
            })

            const notLinkedSessions = patientSession.sessions.filter(session => !session.LinkedToDetailedValue);
            notLinkedSessions.forEach(session => {
                const rowWithValue = createRow(patientSession, session.Treatment, session.Component, session, undefined);
                rows.push(rowWithValue);
            })
        });
        // console.log("rows: ", rows);
        let csvContent = "data:text/csv;charset=utf-8,"
        + rows.map(e => e.join(";")).join("\n");

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "O2matic - Anonomized session data " + TimeUtils.formatDateYYMMDD(Date.now()) + ".csv");
        document.body.appendChild(link);
        link.click();
    }

    return (
        <PageContainer>
            <PageHeader leftAlign><Translate value="DownloadSessionsFromStorage" /></PageHeader>
            <Button onClick={fetchAndConvertData} sx={{ mt: 2, alignSelf: "start", minWidth: '300px' }} variant="contained" startIcon={<SaveIcon />} ><Translate value="GetSessions"/></Button>
        </PageContainer>
    );
}

export default SessionsFromStorage;